/**
 * Backward-compatibility shim: the bracket moved INTO the Competition Design
 * System (components/competition/bracket). Existing imports keep working;
 * new code should import from 'components/competition' directly.
 */
export {
    BracketView as default,
    BracketView,
    InteractiveBracketView,
    buildBracketData,
    isFullyPaired,
    useRoundLabel,
} from '../competition';
